import {
    FETCH_MAIN_AGREEMENT_LIST_REQUEST,
    FETCH_MAIN_AGREEMENT_LIST_FAILURE,
    FETCH_MAIN_AGREEMENT_LIST_SUCCESS,
    CREATE_MAIN_AGREEMENT_REQUEST,
    CREATE_MAIN_AGREEMENT_SUCCESS,
    CREATE_MAIN_AGREEMENT_FAILURE,
    UPDATE_MAIN_AGREEMENT_REQUEST,
    UPDATE_MAIN_AGREEMENT_SUCCESS,
    UPDATE_MAIN_AGREEMENT_FAILURE,
  } from "../../../../redux/actions/manage-property/property-agreement/types";
  
  const initialState = {
    createMainAgreement: { loading: false, data: null, error: null },
    deleteMainAgreement: { loading: false, data: null, error: null },
    updateMainAgreement: { loading: false, data: null, error: null },
    mainAgreementList: { loading: false, data: null, error: null },
  };
  
  const MainAgreement = (state = initialState, action) => {
    // console.log(action.type);
    switch (action.type) {
      //  Request
      case CREATE_MAIN_AGREEMENT_REQUEST:
        return {
          ...state,
          createMainAgreement: { ...initialState.createMainAgreement, loading: true },
        };
      case UPDATE_MAIN_AGREEMENT_REQUEST:
        return {
          ...state,
          updateMainAgreement: { ...initialState.updateMainAgreement, loading: true },
        };
      case FETCH_MAIN_AGREEMENT_LIST_REQUEST: {
        return {
          ...state,
          mainAgreementList: { ...initialState.mainAgreementList, loading: true },
        };
      }
  
  // Success 
      case CREATE_MAIN_AGREEMENT_SUCCESS: {
        // console.log(state.mainAgreementList);
        return {
          ...state,
          createMainAgreement: {
            ...state.createMainAgreement,
            payload: action.payload,
            loading: false,
            error: null,
          },
          mainAgreementList: addNewMainAgreementData(action.payload, {
            ...state.mainAgreementList,
          }),
        };
      }
  
      case UPDATE_MAIN_AGREEMENT_SUCCESS: {
        return {
          ...state,
          updateMainAgreement: {
            ...state.updateMainAgreement,
            loading: false,
            error: null,
            payload: action.payload,
          },
          mainAgreementList: updateMainAgreementData(action.payload, {
            ...state.mainAgreementList,
          }),
        };
      }
  
      case FETCH_MAIN_AGREEMENT_LIST_SUCCESS: {
        // console.log(action.payload);
        return {
          ...state,
          mainAgreementList: {
            ...initialState.mainAgreementList,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
      }
  
      //failure
      case FETCH_MAIN_AGREEMENT_LIST_FAILURE:
        return {
          ...state,
          mainAgreementList: { data: null, loading: false, error: action.error },
        };
        case CREATE_MAIN_AGREEMENT_FAILURE:
          return {
            ...state,
            createMainAgreement: { data: null, loading: false, error: action.error }
          };
        case UPDATE_MAIN_AGREEMENT_FAILURE:
          return {
            ...state,
            updateMainAgreement: { data: null, loading: false, error: action.error }
          };
  
      default:
        return state;
    }
  };
  
  function updateMainAgreementData(dataToUpdate, state) {
    state.data.data = state.data.data.map((obj) => {
      if (obj._id !== dataToUpdate._id) return obj;
      return { ...dataToUpdate };
    });
  
    return state;
  }
  
  
  function addNewMainAgreementData(dataToUpdate, state) {
    state.data.data = [...state.data.data, dataToUpdate];
    state.data.total++;
    return state;
  }
  
  export default MainAgreement;
  